<template>
  <v-container fill-height align-start align-sm-center>
    <v-row justify="center">
      <v-col sm="5">
        <v-card class="mb-4">
          <v-card-title class="headline">
            Shorten URL
          </v-card-title>
          <v-card-text>
            <v-form ref="form" class="mt-2" lazy-validation>
              <v-row>
                <v-col class="py-0" cols="12" sm>
                  <v-text-field v-model="form.url"
                                class="pt-0 v-input--required"
                                label="Long URL"
                                :rules="rules.url"></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="auto">
                  <div class="d-flex justify-space-around">
                    <v-btn color="primary"
                           :disabled="processing"
                           :loading="processing"
                           depressed
                           @click="handleShorten">Shorten</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
            <v-alert color="success" class="mb-0 mt-5 mt-sm-2" text v-if="url">
              <div class="d-flex flex-wrap justify-center justify-lg-space-between align-center">
                <a :href="url" target="_blank" class="mb-2 mb-sm-0">{{ url }}</a>
                <v-btn v-clipboard:copy="url" color="success" text small>
                  Copy
                </v-btn>
              </div>
            </v-alert>
          </v-card-text>
        </v-card>
        <div class="d-flex justify-center">
          <v-btn small text
                 @click="handleLogout">Sign out</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import API from '../../api';

import { NOT_AUTHORIZED } from '../../helpers/events';

export default {
  name: 'Generator',
  data() {
    return {
      form: {
        url: '',
      },
      processing: false,
      url: null,
      rules: {
        url: [(v) => (v && !!v.trim()) || 'URL is required'],
      },
    };
  },
  methods: {
    handleShorten() {
      this.url = null;

      const valid = this.$refs.form.validate();

      if (!valid) {
        return;
      }

      this.processing = true;

      API.encode(this.form)
        .then(({ data: result }) => {
          const {
            success,
            data: { url },
          } = result;

          if (!success || !url) {
            throw new Error('unknown error');
          }

          this.$refs.form.reset();

          this.url = url;
        }).catch((error) => {
          this.$toast.error(`An error occurred: ${error.message}`);
        }).finally(() => {
          this.processing = false;
        });
    },
    handleLogout() {
      this.$eventHub.$emit(NOT_AUTHORIZED);
    },
  },
};
</script>
